/**
 * Trạng thái của action khi muốn invalid cache
 */
export default {
    Import: 1
};
